'use strict';

httpInterceptorAuthorization.$inject = ["authService", "$q"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.httpInterceptorAuthorization = httpInterceptorAuthorization;
/*@ngInject*/
function httpInterceptorAuthorization(authService, /*$state,*/$q) {
    return {
        request: function request(config) {
            if (authService.isAuthenticated) {
                config.headers.Authorization = 'Bearer ' + authService.accessToken;
            }
            return config;
        },
        responseError: function responseError(rejection) {
            if (rejection.status === 401) {
                authService.signIn();
            }

            // if (rejection.status === 403) {
            //     $state.go('unauthenticated');
            // }

            // create a circular dependency with appModule.config
            // if (rejection.status === 403) {
            //     $state.go('unauthorized');
            // }

            return $q.reject(rejection);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/core/httpInterceptorAuthorization.js
// module id = 703
// module chunks = 0